import React, { useState, useEffect, useRef } from 'react';
import * as Styles from './ColorCards.style';
import withErrorBoundary from '@/utils/errorBoundary';
import useLocale from '@/hooks/useLocale';
import { IconCheck, IconAdd, ColorPicker } from 'gatorcomponents';

const ColorCards = ({ brandColor, formValues, setNewFormValue }) => {
  const { studio: studioLocale } = useLocale();
  const { modalLogoGeneration: modalLogoGenerationLocale } = studioLocale;
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef(null);

  const handleChangeColorPicker = (color) => {
    if (color.hex.length) {
      setNewFormValue(brandColor, color.hex);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setShowColorPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Styles.ColorCards>
      {modalLogoGenerationLocale.colors.map(color => (
        <Styles.ColorCard
          key={color.name}
          background={color.background}
          title={color.name}
          onClick={() => {
            const isSelected = formValues[brandColor] === color.background;
            setNewFormValue(brandColor, isSelected ? '' : color.background);
          }}
        >
          {formValues[brandColor] === color.background && (
          <Styles.SelectedColorFeedback>
            <Styles.IconCheckWrapper>
              <IconCheck color="primaryBlue" size="sm" />
            </Styles.IconCheckWrapper>
          </Styles.SelectedColorFeedback>
          )}
        </Styles.ColorCard>
      ))}

      <Styles.ColorCard custom onClick={() => setShowColorPicker(true)} ref={colorPickerRef}>
        <IconAdd color="primaryExtraDark" size="md" />

        <Styles.WrapperColorPicker>
          <ColorPicker
            disableAlpha
            showColorPicker={showColorPicker}
            onChange={color => handleChangeColorPicker(color)}
          />
        </Styles.WrapperColorPicker>
      </Styles.ColorCard>
    </Styles.ColorCards>
  );
};

export default withErrorBoundary(ColorCards, 'ColorCards');
